import { EventEmitter } from '@angular/core';
import { SupervisionError, Panel,SupervisionErrorStatusEnum } from 'solar-bo';
import { SolarService } from '@solar/solar/services/solarservice.service';

import { SolarLoaderBase } from '../../services/solar-loader-base';
import { AlertType } from 'base-models';


export class SupervisLoader extends SolarLoaderBase {


    constructor(public baseService: SolarService
    ) {
        super(baseService);
        this.testWorker();
    }

    testWorker(){
        if (typeof Worker !== 'undefined') {
            // Create a new
            const worker = new Worker('../../../superv-load-worker.worker', { type: 'module' });
            worker.onmessage = ({ data }) => {
              console.log(`page got message: ${data}`);
            };
            //let workerData={id_supervision: this.id_supervision, baseService:this.baseService};
            //worker.postMessage(workerData);

          } else {
            // Web workers are not supported in this environment.
            // You should add a fallback so that your program still executes correctly.
          }
    }

    getSupervisionData(id_supervision: string) {
        this.id_supervision = id_supervision;
        //supervision
        //this.configStatusEvent.emit(this.getStatusMessage(NotificationType.Info, "Loading supervision"));
        //this.getSupervisionModel(id_supervision);
        //paneles
        //issues
        //this.getIssueList(this.id_supervision);
        this.executeFlow();
    }

    executeFlow() {
        switch (this.step) {
            case 0:
                this.getSupervisionModel(this.id_supervision);
                break;   
            case 1:
                this.getIssueList(this.id_supervision);
                break;    
            case 2:
                //panel types
                this.siteGetPanelsType(this.site.id);
                break;  
            case 3:
                //panel 
                this.supervisionGetPanels(this.supervision.id);
                break; 
            case 4:
                this.configureDataTree();
        }
        this.step+=1;
    }

    configureDataTree() {
        let load = this.initialDataLoaded.supervision
            && this.initialDataLoaded.site_panelstype
            && this.initialDataLoaded.site_panels
            && this.initialDataLoaded.supervision_issues;
        if (!load) {
            return;
        }

        this.configStatusEvent.emit(this.getStatusMessage(AlertType.Info, "Configuring supervision data"));
        for (let elem of this.site_panels) {
            let panel: Panel = elem;
            if (panel.id_panel_type && panel.id_panel_type != "") {
                let panelType = this.site_panels_type.find(elem => elem.id == panel.id_panel_type);
                if (panelType) {
                    panel.panelType = panelType;
                }
            }

        }

        let filteredIssues: SupervisionError[] = [];
        
        for (let elem of this.issues) {
            let issue: SupervisionError = elem;
            let issuepanel: any = issue.info.panel;
            try {
                if (issue.info.hasOwnProperty('statusType') == false) {
                    issue.info.statusType = SupervisionErrorStatusEnum.none;
                }
                let issue_panel_id = issuepanel.id;
                if (issue_panel_id) {
                    let panel = this.site_panels.find(elem => elem.id == issuepanel.id);
                    if (panel) {
                        issue.info.panel = panel;
                        filteredIssues.push(issue);
                    }
                }
            }
            catch (err) {
                //console.log("No se ha encontrado panel");
            }
        }

        this.issues = filteredIssues;

        let res = { haserror: "", "supervision": this.supervision, "site_panels_type": this.site_panels_type, "site_panels": this.site_panels, "issues": filteredIssues };
        this.configEndEvent.emit(res);

    }

}